import Mockman from "mockman-js";
import "./Mockman.css";
const MockMan = () => {
  return <Mockman />;
};

export { MockMan };
